<div>
  <h2 class="dashboardHeading" data-cy="dashboardHeading">{{ dashboardHeading }}</h2>
  <!-- The data has not come back yet -->
  <ds-localized-spinner
    class="block"
    [dataLoading]="dataLoading$ | async"
    [loadingMessage]="loadingMessage"
  >
  </ds-localized-spinner>

  @if ((dataLoading$ | async) === false && (billingTileAccountsList$ | async).length > 0) {
    <div class="flex items-center dashboard">
      <!-- Total amount -->
      <div class="flex totalContainer">
        @if ((manualPaymentTotal$ | async)?.total !== 0) {
          <div
            class="totalBox"
            [ngClass]="{ totalLeft: (autopayOrAFTTotal$ | async)?.total !== 0 }"
            data-cy="paymentSection"
          >
            <p class="totalHeading">{{ (manualPaymentTotal$ | async)?.title }}</p>
            <div class="flex amount">
              <div class="amount-big" data-cy="amountDollars">
                {{ (manualPaymentTotal$ | async)?.dollars }}
              </div>
              <div class="amount-small" data-cy="amountCents">
                {{ (manualPaymentTotal$ | async)?.cents }}
              </div>
            </div>
          </div>
        }
        @if ((autopayOrAFTTotal$ | async)?.total !== 0) {
          <div class="totalBox" data-cy="paymentSection">
            <p class="totalHeading">{{ (autopayOrAFTTotal$ | async)?.title }}</p>
            <div class="flex amount">
              <div class="amount-big" data-cy="amountDollars">
                {{ (autopayOrAFTTotal$ | async)?.dollars }}
              </div>
              <div class="amount-small" data-cy="amountCents">
                {{ (autopayOrAFTTotal$ | async)?.cents }}
              </div>
            </div>
          </div>
        }
      </div>
      <!-- Billing tiles -->
      <div class="tileContainer">
        <!-- web-view: display 'More' with more than 4 tiles -->
        <div class="billingTiles webView">
          @for (
            account of billingTileAccountsList$ | async | slice: 0 : webSlicedLength;
            track account
          ) {
            <ds-billing-tile
              [account]="account"
              data-cy="billingTile"
              (click)="billingTileClicked()"
              class="billingTile"
            ></ds-billing-tile>
          }
        </div>
        @if ((billingTileAccountsList$ | async).length > 4) {
          <div class="pad-10 webView">
            <p>
              <a class="pad-right-10" (click)="toggleBillingTileListWeb()">
                {{ webSlicedLength > 4 ? 'Less' : 'More' }}
              </a>
              <span
                [ngClass]="
                  webSlicedLength > 4 ? 'icon-chevron-up-thick' : 'icon-chevron-down-thick'
                "
              ></span>
            </p>
          </div>
        }
        <!-- mobile-view: display 'More' with more than 3 tiles -->
        <div class="billingTiles mobileView">
          @for (
            account of billingTileAccountsList$ | async | slice: 0 : mobileSlicedLength;
            track account
          ) {
            <ds-billing-tile
              [account]="account"
              data-cy="billingTile"
              (click)="billingTileClicked()"
              class="billingTile"
            ></ds-billing-tile>
          }
        </div>
        @if ((billingTileAccountsList$ | async).length > 3) {
          <div class="pad-10 mobileView">
            <p>
              <a class="pad-right-10" (click)="toggleBillingTileListMobile()">
                {{ mobileSlicedLength > 3 ? 'Less' : 'More' }}
              </a>
              <span
                [ngClass]="
                  mobileSlicedLength > 3 ? 'icon-chevron-up-thick' : 'icon-chevron-down-thick'
                "
              ></span>
            </p>
          </div>
        }
      </div>
    </div>
  }
</div>
